module.exports = __webpack_public_path__ + "static/elephant9-f7ab90bcb16cd71ef88fe60fb0c7a837.jpeg";